import * as React from 'react';
import { getItemSummaryPhotos, getItemSummaryTitle } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { imagePlaceholder } from '@/utils/urls';
import { useAppSelector } from '@/redux/hooks';
import CarouselPhoto from './components/CarouselPhoto/CarouselPhoto';
import NextItemImagePreloader from '@/pages/BiddingConsole/components/InlineLightboxCarousel/components/NextItemImagePreloader';
import Slider from 'react-slick/lib/slider';
import styled from 'styled-components';

type Props = {
    beforeChange: (oldIndex: number, newIndex: number) => void;
    catalogId: number;
};

const ItemImageCarousel = ({ beforeChange, catalogId }: Props) => {
    const firstRender = React.useRef<boolean>(true);
    // slick slider is untyped
    const slickSliderRef = React.useRef<any>(null);

    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const photos = useAppSelector((state) => getItemSummaryPhotos(state, itemId));

    // reset slick slider to image 0 when item changes
    React.useEffect(() => {
        if (!firstRender.current) {
            slickSliderRef?.current?.slickGoTo(0);
        }
    }, [itemId]);

    React.useEffect(() => {
        firstRender.current = false;
    }, []);

    const settings = {
        adaptiveHeight: false,
        arrows: false,
        beforeChange,
        dots: false,
        infinite: false,
        initialSlide: 0,
        lazyLoad: false,
        ref: slickSliderRef,
        slidesToScroll: 1,
        slidesToShow: 1,
    };

    return (
        <>
            <Slider {...settings}>
                {photos.length
                    ? photos.map((imageNumber, imageIndex) => (
                          <CarouselPhoto
                              imageIndex={imageIndex}
                              imageNumber={imageNumber}
                              itemId={itemId}
                              key={`${itemId}-${imageNumber}`}
                          />
                      ))
                    : [
                          <div key={0}>
                              <Placeholder
                                  alt={`Missing ${title} preview.`}
                                  src={imagePlaceholder}
                              />
                          </div>,
                      ]}
            </Slider>
            <NextItemImagePreloader
                itemId={itemId}
                width={500}
            />
        </>
    );
};

export default ItemImageCarousel;

const Placeholder = styled.img`
    height: 100%;
    width: 100%;
`;
